module.exports = __webpack_public_path__ + "img/arrow.ffad452a.svg";